/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";
import dynamic from "next/dynamic";
import Image from "next/future/image";
import cx from "classnames";
import loginImage from "./login-image.png";

const AppFooterDesktop = dynamic(
  () => import("components/AppFooter/AppFooterDesktop")
);

import layoutStyles from "../Layout/Layout.module.scss";
import styles from "./LoginLayout.module.scss";

import { IConfigurationModel } from "@nf/common";

interface LoginLayoutProps {
  children: React.ReactNode;
  config: IConfigurationModel;
}

const LoginLayout = ({ children, config }: LoginLayoutProps) => {
  return (
    <div className={cx(layoutStyles.container, styles.layout)}>
      <section>
        <Image
          src={loginImage}
          className={styles.image}
          alt="Login Image"
          width={534}
          height={857}
        />
        {children}
      </section>

      <div className={cx(styles.div)}>
        <AppFooterDesktop configuration={config} />
      </div>
    </div>
  );
};

export default LoginLayout;
